/* eslint-disable global-require */

import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';

import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import { AppActionTypes } from './appModule/actions';

import sagas from './sagas';
import makeRootReducer from './reducers';

import { history } from '../routes/utils';

const sagaMiddleware = createSagaMiddleware();

export const create = (initialState = {}) => {
  const logger = createLogger({
    predicate: (getState, action) => {
      return false && action.type !== AppActionTypes.INC_SEARCH_LOADER && process.env.NODE_ENV !== 'production';
    },
  });
  const middleware = [routerMiddleware(history), sagaMiddleware, thunk, logger];

  const composeEnhancers =
    process.env.NODE_ENV !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose;

  const store = createStore(
    makeRootReducer({}, history),
    initialState,
    composeEnhancers(applyMiddleware(...middleware)),
  );

  store.runSaga = sagaMiddleware.run;
  store.history = history;
  store.injectedSagas = {}; // Saga registry
  store.injectedReducers = {}; // Reducer registry
  // store.unsubscribeHistory = browserHistory.listen(LocationActions.updateLocation(store));

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default;
      store.replaceReducer(reducers(store.injectedReducers, history));
    });
  }

  return store;
};

export const store = create({});
store.runSaga(sagas);

export default create;
